import React from "react";
import { Icon } from "antd";
import styles from "./footer.scss";

const Footer = ({ onSubmit, onCancel, canSubmit, submitting }) => (
  <div className={styles.container}>
    <button type="button" onClick={onCancel} className={styles.cancelButton}>
      {"Otkaži"}
    </button>
    <button
      type="button"
      disabled={!canSubmit}
      onClick={onSubmit}
      className={styles.submitButton}
    >
      {submitting ? (
        <Icon type="loading" />
      ) : (
        "Pošalji"
      )}
    </button>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/Footer/index.tsx